import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';

export default function TrendingCard({ trendingCards, title }) {
    const history = useHistory();

    const viewProduct = (value) => {
        history.push(`/product/${value._id}/view`);
    };

    return (
        <motion.div className="relative px-2 bg-white drop-shadow-lg py-10 w-full flex flex-col">
            <span className="text-xl font-bold my-5">Trending products based on {title} </span>
            <motion.div className="w-full overflow-x-auto whitespace-nowrap px-2 py-2">
                {trendingCards &&
                    trendingCards.map((vehicle, index) => (
                        <motion.div
                            key={index}
                            className="inline-block mr-2  cursor-pointer last:mr-0 min-w-[120px]"
                            onClick={() => viewProduct(vehicle)}
                        >
                            <img
                                src={vehicle.images[0]}
                                className="h-80 w-80 object-contain rounded-md"
                                alt="vehicle"
                            />
                        </motion.div>
                    ))}
            </motion.div>
        </motion.div>
    );
}
